import { GlButton, GlButtonGroup, GlTooltipDirective, GlHoverLoadDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { InternalEvents } from '../../tracking/index.js?vue3';
import InlineBlamePopover from './inline_blame_popover.vue?vue3';
import UserCalloutDismisser from '../../vue_shared/components/user_callout_dismisser.vue?vue3';
import { RICH_BLOB_VIEWER, RICH_BLOB_VIEWER_TITLE, RICH_BLOB_VIEWER_LABEL, SIMPLE_BLOB_VIEWER, SIMPLE_BLOB_VIEWER_TITLE, SIMPLE_BLOB_VIEWER_LABEL, BLAME_VIEWER, BLAME_TITLE } from './constants';
export default {
    name: 'BlobHeaderViewerSwitcher',
    components: {
        GlButtonGroup,
        GlButton,
        InlineBlamePopover,
        UserCalloutDismisser
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        GlHoverLoad: GlHoverLoadDirective
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        value: {
            type: String,
            default: SIMPLE_BLOB_VIEWER,
            required: false
        },
        showViewerToggles: {
            type: Boolean,
            required: false,
            default: false
        },
        showBlameToggle: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'blame-loading-started',
        'blame',
        'input',
        'preload-blame'
    ],
    computed: {
        isSimpleViewer () {
            return this.value === SIMPLE_BLOB_VIEWER;
        },
        isRichViewer () {
            return this.value === RICH_BLOB_VIEWER;
        },
        isBlameViewer () {
            return this.value === BLAME_VIEWER;
        }
    },
    methods: {
        switchToViewer (viewer) {
            if (viewer === BLAME_VIEWER) {
                this.$emit('blame-loading-started');
                this.$emit('blame');
                this.trackEvent('open_blame_viewer_on_blob_page');
            }
            if (viewer !== this.value) {
                this.$emit('input', viewer);
            }
        }
    },
    SIMPLE_BLOB_VIEWER,
    RICH_BLOB_VIEWER,
    SIMPLE_BLOB_VIEWER_TITLE,
    SIMPLE_BLOB_VIEWER_LABEL,
    RICH_BLOB_VIEWER_TITLE,
    RICH_BLOB_VIEWER_LABEL,
    BLAME_TITLE,
    BLAME_VIEWER
};
